import Tracker from "../prop-trackers/tracker.js";
import TrackerGroup from "../prop-trackers/tracker-group.js";
import Zipper from "./zipper.js";

class ValueCombiner extends Tracker {
    constructor() {
        super();
    }

    setValue(id, value) {
        throw new Error("Method .setValue is not implemented");
    }

    deleteValue(id) {
        throw new Error("Method .deleteValue is not implemented");
    }
}

class CombinerForEach extends Tracker {
    constructor(createValueCombiner) {
        super();

        this._createValueCombiner = createValueCombiner;

        this._zipper = new Zipper();

        this._valueCombiners = new Map();
        this._valueCombinerSetSources = new Map();
        this._valueCombinerGroup = new TrackerGroup();

        const needsUpdate = () => this.protected_needsUpdate();
        this._zipper.listenNeedsUpdate(needsUpdate);
        this._valueCombinerGroup.listenNeedsUpdate(needsUpdate);
    }

    setSource(sourceKey, sourceTracker) {
        this._zipper.setSource(sourceKey, sourceTracker);
    }

    deleteSource(sourceKey, sourceTracker) {
        this._zipper.deleteSource(sourceKey);
    }

    protected_startUpdate() {
        this._zipper.update(({ trackers }) => {
            for (const tracker of trackers) {
                tracker.update(({ userdata: key, props }) => {
                    let combiner = this._valueCombiners.get(key);
                    let combinerSetSources = this._valueCombinerSetSources.get(key);

                    for (const { key: sourceKey, oldExists, oldValue, newExists, newValue } of props.iterateModified()) {
                        if (newExists) {
                            if (!combiner) {
                                combiner = this._createValueCombiner(key);
                                combinerSetSources = new Set();
                                this._valueCombiners.set(key, combiner);
                                this._valueCombinerSetSources.set(key, combinerSetSources);
                                this._valueCombinerGroup.add(combiner);
                            }

                            combiner.setValue(sourceKey, newValue);
                            combinerSetSources.add(sourceKey);
                        } else {
                            combiner.deleteValue(sourceKey);
                            combinerSetSources.delete(sourceKey);

                            if (combinerSetSources.size === 0) {
                                this._valueCombinerGroup.remove(combiner);
                                this._valueCombiners.delete(key);
                                this._valueCombinerSetSources.delete(key);
                            }
                        }
                    }
                });
            }
        });

        return this._valueCombinerGroup.startUpdate();
    }

    protected_finishUpdate() {
        this._valueCombinerGroup.finishUpdate();
    }
}

CombinerForEach.ValueCombiner = ValueCombiner;

export default CombinerForEach;
export { CombinerForEach, ValueCombiner };
